module.exports = __webpack_public_path__ + "fonts/Inter-100-latin28.8e433c0.woff2";